function slugify(input: string) {
  return input.toLowerCase().replace(/ /g, '-').replace(/[^a-z0-9-]/g, '');
}
export function makeStepId(stepName: string) {
  return slugify(stepName);
}
export function makeFieldId(stepName: string, fieldName: string) {
  return slugify(`${stepName}-${fieldName}`);
}